import { useState, useEffect, useCallback } from 'react';
import { listCourses } from '../api/assetServiceClient';
import type { CourseOut } from '../types/catalog';

export function useStudentCourses(params?: { grade?: number; book?: string }) {
  const [courses, setCourses] = useState<CourseOut[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCourses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const items = await listCourses({
        grade: params?.grade,
        book: params?.book,
      });
      setCourses(items);
    } catch (err: unknown) {
      const msg = err instanceof Error ? err.message : 'Failed to load courses';
      setError(msg);
      setCourses([]);
    } finally {
      setLoading(false);
    }
  }, [params?.grade, params?.book]);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);

  return { courses, loading, error, refetch: fetchCourses };
}
